import Vue from 'vue'
import VueRouter from 'vue-router'
import DrawingBoard from '../views/DrawingBoard.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: '/drawingboard'
  },
  {
    path: '/about',
    name: 'About',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  },
  {
    path: '/drawingboard',
    name: 'DrawingBoard',
      component: DrawingBoard,
      meta: {
          requiresAuth: true,
      }
  },

]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})


export default router
